/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ReactElement, ReactNode } from 'react';

import { Component as SuccessIcon } from 'icons/icon-circle--success.svg';

type Props = {
  id: string,
  details: string,
  mealPrep: ReactNode,
  isSelected: boolean,
  images: Record<string, string>,
  handlePlanSelect: ()=> void,
}

function MealPreferenceCard({
  id,
  details,
  mealPrep,
  isSelected,
  images,
  handlePlanSelect,
}: Props): ReactElement {
  const { lg_1x: lg1x, lg_2x: lg2x, sm_1x: sm1x, sm_2x: sm2x } = images;

  return (
    <div
      role="button"
      tabIndex={0}
      className={[
        'c-card c-modal-meal-preferences-new__card',
        isSelected ? 'active_card' : '',
      ].join(' ')}
      onClick={handlePlanSelect}
      onKeyPress={
        (e) => e.key === 'Enter' && handlePlanSelect()
      }
      data-cy="meal-preference-card"
      aria-label={`Select ${id}`.replace(/_/g, ' ')}
    >
      <img
        src={lg1x}
        srcSet={`${lg1x} 1x, ${lg2x} 2x`}
        className={[
          'c-modal-meal-preferences-new__card_plan_image',
          'd-none',
          'd-md-flex',
        ].join(' ')}
        alt=""
      />
      <img
        src={sm1x}
        srcSet={`${sm1x} 1x, ${sm2x} 2x`}
        className={[
          'c-modal-meal-preferences-new__card_plan_image',
          'd-flex',
          'd-md-none',
        ].join(' ')}
        alt=""
      />
      <div className="c-modal-meal-preferences-new__card_details">
        <div
          className={[
            'c-heading',
            'c-heading--brand-7',
            'c-modal-meal-preferences-new__card_plan_title',
          ].join(' ')}
        >
          {mealPrep}
        </div>
        <p className="u-text--xs mt-md-2 mb-0">
          <span>{details}</span>
        </p>
      </div>

      {isSelected && (
        <div className="c-modal-meal-preferences-new__card_plan_icon">
          <SuccessIcon
            height="20"
            width="20"
            className="c-svg-fill-primary-color"
          />
        </div>
      )}
    </div>
  );
}

export default MealPreferenceCard;
